<template>
    <Head title="Notification Preferences | Settings" />
    <div class="px-4 md:px-8" data-page="settings">
        <!-- Page header -->
        <div class="sm:flex sm:justify-between sm:items-center mb-10">
            <!-- Left: Title -->
            <div class="mb-4 sm:mb-0">
                <h1 class="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
                    Account Settings
                </h1>
            </div>
        </div>
        <!-- END PAGE HEADER -->

        <!-- TABLE -->
        <div
            class="lg:bg-white dark:bg-slate-800 dark:lg:bg-slate-800 lg:shadow-lg dark:lg:shadow-slate-900/50 lg:rounded-sm lg:border lg:border-gray-200 dark:lg:border-slate-700 mb-8"
        >
            <div class="flex flex-col lg:flex-row">
                <div
                    class="flex flex-nowrap p-0 lg:px-5 lg:py-10 bg-white dark:bg-slate-800 shadow-lg dark:shadow-slate-900/50 rounded-sm border border-gray-200 dark:border-slate-700 mb-8 lg:border-none lg:shadow-none"
                >
                    <SettingsNav />
                </div>

                <div
                    class="p-5 lg:px-0 lg:py-0 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-gray-200 mb-8 lg:mb-0 lg:border-r-0 lg:border-x-0 lg:border-y-0 lg:!border-l lg:!border-gray-200 lg:shadow-none"
                    style="grow: 1"
                >
                    <div class="flex flex-nowrap flex-col lg:px-10 lg:py-10">
                        <div class="mb-5">
                            <h2
                                class="text-xl lg:text-2xl text-gray-800 dark:text-gray-100 font-bold mb-5"
                            >
                                Notification Preferences
                            </h2>

                            <section class="mb-8">
                                <h2
                                    class="text-xl lg:text-2xl leading-snug text-gray-800 dark:text-gray-100 font-bold mb-1"
                                >
                                    Manage Your Notification Preferences
                                </h2>
                                <p class="mb-5">
                                    Choose which email notifications that you'd
                                    like to receive.
                                </p>

                                <div
                                    v-if="loading"
                                    class="flex justify-center items-center p-8"
                                >
                                    <div
                                        class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 dark:border-gray-100"
                                    ></div>
                                </div>
                                <div v-else>
                                    <NotificationToggles
                                        :has-active-access="hasActiveAccess"
                                    />
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Layout from '@/Layouts/Main.vue';
import { Head, Link } from '@inertiajs/vue3';
import { ref, onMounted } from 'vue';
import NotificationToggles from '@/components/user-settings/notification-toggles.vue';
import SettingsNav from '@/Pages/Settings/partials/nav.vue';

const props = defineProps({
    hasActiveAccess: Boolean,
});

const loading = ref(false);

onMounted(() => {
    // The NotificationToggles component will handle its own API calls
});

defineOptions({
    layout: Layout,
});
</script>
